export namespace Articles
{
    export class Article
    {
        public title: string;
        public href: string;
        public pubDate: Date;
        public pub: string;
        public pubLink: string;
        public imageLink: string;
        public imageCredit: string;
        public imageCreditLink: string;
    }

    export const articles: Article[] = 
    [
        {
            title: "Swept Downstream: On A Year Of Education During The Pandemic",
            href: "https://www.chronogram.com/hudsonvalley/swept-downstream-on-a-year-of-education-during-the-pandemic/Content?oid=12894239",
            imageLink: "https://media1.fdncms.com/chronogram/imager/u/magnum/12894236/20210326_145749_1_.jpg",
            pubDate: new Date("5/1/2021"),
            pub: "Chronogram", 
            pubLink: "https://www.chronogram.com",
            imageCredit: "Me",
            imageCreditLink: ""
        },
        {
            title: "I Got Vaccinated: Here's What Happened!",
            href: "https://resources.finalsite.net/images/v1622128731/onteorak12nyus/gg8ggweldpykdh7a7ul1/Talon-May2021.pdf",
            imageLink: "/images/articles/pfizer.jpg",
            pubDate: new Date("5/1/2021"),
            pub: "Onteora Talon", 
            pubLink: "https://ohs.onteora.k12.ny.us",
            imageCredit: "Flickr",
            imageCreditLink: ""
        },
        
        {
            title: "New Learning Spaces at Onteora",
            href: "https://resources.finalsite.net/images/v1622128731/onteorak12nyus/gg8ggweldpykdh7a7ul1/Talon-May2021.pdf",
            imageLink: "/images/articles/onteora-learning.jpg",
            pubDate: new Date("5/1/2021"),
            pub: "Onteora Talon", 
            pubLink: "https://ohs.onteora.k12.ny.us",
            imageCredit: "Onteora School District",
            imageCreditLink: ""
        },
        {
            title: "What Does Toxic Masculinity Mean to You?",
            href: "https://resources.finalsite.net/images/v1611670474/onteorak12nyus/qca1bfqtwzdbx1twxd2i/Talon012621.pdf",
            imageLink: "/images/articles/toxic-masculity.jpg",
            pubDate: new Date("1/1/2021"),
            pub: "Onteora Talon", 
            pubLink: "https://ohs.onteora.k12.ny.us",
            imageCredit: "Tahlula Potter",
            imageCreditLink: ""
        },
        {
            title: "Protesting in the era of Covid-19: A student perspective",
            href: "https://hudsonvalleyone.com/2020/08/11/protesting-in-the-era-of-covid-19-a-student-perspective/",
            imageLink: "https://hudsonvalleyone.com/wp-content/uploads/2020/08/BLM-Phoenicia-700x467-1.jpg",
            pubDate: new Date("8/11/2020"),
            pub: "Hudson Valley One", 
            pubLink: "https://hudsonvalleyone.com",
            imageCredit: "Violet Snow",
            imageCreditLink: ""
        },
        {
            title: "My Experience With Standardized Tests During a Pandemic",
            href: "https://resources.finalsite.net/images/v1593018151/onteorak12nyus/bcz1ufpjczg4vodstgee/Talon-June2020.pdf",
            imageLink: "",
            pubDate: new Date("6/1/2020"),
            pub: "Onteora Talon", 
            pubLink: "https://ohs.onteora.k12.ny.us",
            imageCredit: "",
            imageCreditLink: ""
        },
        {
            title: "The Good, The Bad, and the Ugly of Social Media",
            href: "https://resources.finalsite.net/images/v1589374713/onteorak12nyus/ybufipyjliu0kjgj2vs7/Talon-May2020.pdf",
            imageLink: "/images/articles/ugly-social-media.png",
            pubDate: new Date("5/1/2020"),
            pub: "Onteora Talon", 
            pubLink: "https://ohs.onteora.k12.ny.us",
            imageCredit: "Natalie Horberg",
            imageCreditLink: ""
        }


        
    ];
}